<div style="height: 100%; width: 100%">
  <router-outlet></router-outlet>
</div>

<app-consent-banner
  *ngIf="!IN_NATIVE_APP && (hasGivenChoice$ | async) === false && !isEmbed"
></app-consent-banner>
